import { __assign, __rest } from "tslib";
import React from 'react';
import Button from '@atlaskit/button';
export default React.forwardRef(function (_a, ref) {
    var truncationWidth = _a.truncationWidth, props = __rest(_a, ["truncationWidth"]);
    return (React.createElement(Button, __assign({}, props, { ref: ref, theme: function (currentTheme, themeProps) {
            var _a = currentTheme(themeProps), buttonStyles = _a.buttonStyles, rest = __rest(_a, ["buttonStyles"]);
            return __assign({ buttonStyles: __assign(__assign({}, buttonStyles), (truncationWidth
                    ? { maxWidth: truncationWidth + "px !important" }
                    : { flexShrink: 1, minWidth: 0 })) }, rest);
        } })));
});
//# sourceMappingURL=Button.js.map